
    <option *ngFor="let c of ps.psContractTypes" value="{{ c.contractTypeCode }}">{{ c.contractTypeName }}</option>

